import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type SierraGatewayDeviceDetailsEndpointSpecification = ApiEndpointSpecification;
export const SierraGatewayDeviceDetailsEndpointSpecification: SierraGatewayDeviceDetailsEndpointSpecification = {
    url: '/api/sierradevice/device',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'SierrawirelessGatewayDeviceDetailsRequestParams',
    requestBodySchemaName: 'SierrawirelessGatewayDeviceDetailsRequestBody',
    okResponseSchemaName: 'SierrawirelessGatewayDeviceDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSierraGatewayDeviceDetails = Helpers.makeApiRequestFn<
    Types.SierraWirelessGatewayDeviceDetailsRequestParams,
    Types.SierraWirelessGatewayDeviceDetailsRequestBody,
    Types.SierraWirelessGatewayDeviceDetailsOkResponse
>(SierraGatewayDeviceDetailsEndpointSpecification);
